import React from "react";
import { Home } from "react-feather";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

const Breadcrumb = ({title, parent, isStack}) => {
	const breadcrumbStyle = {
		fontWeight:"400",
		fontSize:"14px",
		lineHeight:"16px",
		color:"#2A3D4A",
	};

	return (
		<Container fluid={true}>
			<div className="page-header" style={isStack ? {paddingTop: 0} : null}>
				<Row style={isStack ? {display: "flex", flexDirection: "column-reverse"} : null}>
					<Col lg="6" style={isStack ? {maxWidth: "none", marginTop: "8px", paddingLeft: 0} : null}>
						<div className="page-header-left">
							<h3 style={isStack ? { fontWeight: "400", fontSize: "30px", lineHeight: "35px", color: "#000", textTransform: "capitalize" } : null}>
								{title}
							</h3>
						</div>
					</Col>
					<Col lg="6" style={isStack ? {maxWidth: "none", paddingLeft: 0} : null}>
						<ol className="breadcrumb pull-right" style={isStack ? {float: "none", alignItems: "center"} : { display: "flex", alignItems: "baseline" }}>
							{
								!isStack && (
									<li className="breadcrumb-item">
										<Link to="mutikart-admin/dashboard">
											<Home />
										</Link>
									</li>
								)
							}
							{
								!!parent && (
									<li className="breadcrumb-item">
										{
											!!parent?.path
											? (
												<>
													<Link to={parent.path} style={{ ...breadcrumbStyle, color: "#0056CC" }}>
														{parent.label}
													</Link>
												</>
											)
											: parent
										}
									</li>
								)
							}
							<li className="breadcrumb-item active" style={{ ...breadcrumbStyle, color: "#2A3D4A" }}>{title}</li>
						</ol>
					</Col>
				</Row>
			</div>
		</Container>
	);
};

export default Breadcrumb;
